export default __webpack_public_path__ + "static/7-d751aad257acbb0e900f1795a7fe63d5.png";